import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import get from 'lodash/get';
import {
  fulfillmentOptions,
  ALL_ONLINE_ORDERING_FULFILLMENT_METHODS
} from 'constants/fulfillmentOptions';
import OrderAlertManager from 'bento-ordering/locations/components/OrderAlertManager';
import OrderSettingContainer from 'bento-ordering/menus/components/OrderSettingContainer';
import { generatePath } from 'bento-ordering/utils/generatePath';
import { closeLocationDetailModal } from 'bento-ordering/locations/actions/locations';
import { MENU } from 'bento-ordering/menus/constants/entities';
import { toggleAlertStatus } from 'bento-ordering/base/actions/alertStatus';
import withOrderSetting from 'bento-ordering/base/hoc/withOrderSetting';

/**
 * This component handles the display of alerts (if any) and order settings
 * on mobile.
 */
class OrderSettingRoute extends React.Component {
  static propTypes = {
    alert: PropTypes.string,
    metaData: PropTypes.object,
    fulfillmentMethod: PropTypes.oneOf([
      fulfillmentOptions.DELIVERY,
      fulfillmentOptions.PICKUP
    ]),
    today: PropTypes.string,
    isAsapAvailableForPickup: PropTypes.bool,
    isAsapAvailableForDelivery: PropTypes.bool,
    nextAvailablePickupTime: PropTypes.object,
    nextAvailableDeliveryTime: PropTypes.object,
    cartWorkingCopy: PropTypes.object,
    availableFulfillmentOptions: PropTypes.arrayOf(
      PropTypes.oneOf(ALL_ONLINE_ORDERING_FULFILLMENT_METHODS)
    ),
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired
  };

  /**
   * This same logic is used in Modal, OrderSettingModal, LocationDetailModal.
   * If the user close the modal we want to do the following:
   * 1) reset to the original fulfillment options
   * 2) reset the logic to determine if cart items are available
   */
  closeModal = () => {
    const { match, history, dispatch, alert } = this.props;
    dispatch(
      closeLocationDetailModal(() => {
        const slug = match.params.slug;
        history.push(generatePath(MENU, 'menu', { slug }));
      })
    );
    // close open alert
    dispatch(toggleAlertStatus(alert));
  };

  render() {
    const {
      isAsapAvailableForDelivery,
      isAsapAvailableForPickup,
      alert,
      metaData,
      fulfillmentMethod,
      nextAvailablePickupTime,
      nextAvailableDeliveryTime,
      today,
      cartWorkingCopy,
      availableFulfillmentOptions
    } = this.props;

    return (
      <React.Fragment>
        <OrderSettingContainer
          closeModal={this.closeModal}
          isAsapAvailableForPickup={isAsapAvailableForPickup}
          isAsapAvailableForDelivery={isAsapAvailableForDelivery}
        />
        {alert && (
          <OrderAlertManager
            alert={alert}
            metaData={metaData}
            fulfillmentMethod={fulfillmentMethod}
            pickupTime={get(nextAvailablePickupTime, 'open_time')}
            pickupDate={get(nextAvailablePickupTime, 'date')}
            deliveryTime={get(nextAvailableDeliveryTime, 'open_time')}
            deliveryDate={get(nextAvailableDeliveryTime, 'date')}
            isAsapAvailableForPickup={isAsapAvailableForPickup}
            isAsapAvailableForDelivery={isAsapAvailableForDelivery}
            today={today}
            cartWorkingCopy={cartWorkingCopy}
            availableFulfillmentOptions={availableFulfillmentOptions}
          />
        )}
      </React.Fragment>
    );
  }
}

export default withRouter(withOrderSetting(OrderSettingRoute));
